import React, { ReactNode } from 'react';
import { useAuth } from '../../../hooks/common/useAuth';
import { PermissionAction, PermissionSubjects } from '../../../types/common/PermissionType';

interface ICanProps {
  a: PermissionSubjects;
  I: PermissionAction;
  children: React.ReactElement | null;
}

const Can = (props: ICanProps): ReactNode => {
  const { I, a, children } = props;
  const { userPermissions } = useAuth();
  const hasPermission = userPermissions?.[a]?.[I] === true;

  return hasPermission ? children : false;
};

export default Can;
